$(document).ready(function() {
    function applyPhoneMask(input) {
        let value = input.val().replace(/\D/g, '');
        let formatted = '';

        if (value.length > 0) {
            formatted = '+7 ';

            if (value.length > 1) {
                if (value[0] === '7' || value[0] === '8') {
                    value = value.substring(1);
                }

                const areaCode = value.substring(0, 3);
                if (areaCode) {
                    formatted += areaCode;
                }

                if (value.length > 3) {
                    formatted += ' ' + value.substring(3, 6);
                }

                if (value.length > 6) {
                    formatted += ' ' + value.substring(6, 8);
                }

                if (value.length > 8) {
                    formatted += ' ' + value.substring(8, 10);
                }
            }
        }

        input.val(formatted);
    }

    $('.phone-mask').on('input', function() {
        applyPhoneMask($(this));
    });

    $('.phone-mask').each(function() {
        applyPhoneMask($(this));
    });
});
